var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoorkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.297,
    height: 104.22,
    viewBox: "0 0 104.297 104.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-in",
    transform: "translate(0.602 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69797",
    "data-name": "Path 69797",
    d: "M21.382,13.773A.945.945,0,0,0,20.057,14a11.905,11.905,0,0,0,0,13.762.95.95,0,0,0,1.55-1.1,10.005,10.005,0,0,1,0-11.568.947.947,0,0,0-.225-1.322Z",
    transform: "translate(15.65 9.128)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69798",
    "data-name": "Path 69798",
    d: "M21.782,19.312a4.833,4.833,0,0,1,1.145-3.149.952.952,0,0,0-1.459-1.223,6.809,6.809,0,0,0,0,8.739.95.95,0,1,0,1.454-1.221,4.9,4.9,0,0,1-1.14-3.146Z",
    transform: "translate(18.737 10.697)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69799",
    "data-name": "Path 69799",
    d: "M104.347,17.227H79.967V13.174a8.559,8.559,0,0,0-8.549-8.549h-30.4a8.559,8.559,0,0,0-8.549,8.549V64.455L13.83,63.4a8.726,8.726,0,1,0-.507,17.44c.17,0,.339,0,.507-.015L32.47,79.762V99.3a8.559,8.559,0,0,0,8.551,8.549h30.4A8.559,8.559,0,0,0,79.967,99.3V52.048h24.38a3.488,3.488,0,0,0,3.483-3.483V20.7A3.488,3.488,0,0,0,104.347,17.227ZM52.1,28.083H105.93v6.976H52.1ZM105.93,20.7v5.481H52.1V20.7a1.583,1.583,0,0,1,1.583-1.583h50.66A1.583,1.583,0,0,1,105.93,20.7ZM13.723,78.926a6.839,6.839,0,1,1-.4-13.645h.4l42.451,2.411a4.413,4.413,0,0,1,0,8.812h0L33.438,77.8H33.4Zm42.555-.507a6.31,6.31,0,0,0,0-12.6l-6.333-.357a9.177,9.177,0,1,1-.028,13.319l6.35-.36ZM78.067,99.3a6.659,6.659,0,0,1-6.649,6.649h-30.4A6.659,6.659,0,0,1,34.373,99.3V79.653l13.1-.742a11.087,11.087,0,1,0,.018-13.6l-13.119-.745V13.174a6.659,6.659,0,0,1,6.649-6.649h30.4a6.659,6.659,0,0,1,6.649,6.649v4.053H53.687A3.488,3.488,0,0,0,50.2,20.71V48.573a3.488,3.488,0,0,0,3.483,3.475h24.38Zm26.28-49.14H53.687A1.586,1.586,0,0,1,52.1,48.573V36.959H105.93V48.565a1.586,1.586,0,0,1-1.583,1.591Z",
    transform: "translate(-4.635 -4.625)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorkey);
export default __webpack_public_path__ + "static/media/doorkey.f1c938babbad3e0b01142baf8ef3acfb.svg";
export { ForwardRef as ReactComponent };